import * as React from "react";
import styled, { css } from "styled-components";
import { Alert, Col, Row } from "components/bootstrap";
import { Link } from "components/common";
import usePermissions from "hooks/usePermissions";
import AIManagementRoutes from "ai-management/Routes";
import ProviderName from "ai-management/components/ProviderName";
import useAIFeaturesStatus from "ai-management/hooks/useAIFeaturesStatus";
const Alerts = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.sm};
  `
);
const StyledAlert = styled(Alert)`
  margin: 0;
`;
const OnModelProvidersPage = ({ show }) => show ? /* @__PURE__ */ React.createElement(React.Fragment, null, " ", "on the ", /* @__PURE__ */ React.createElement(Link, { to: AIManagementRoutes.MODEL_PROVIDERS }, "Model Providers"), " page") : null;
const issueAlertContent = (issue, link) => {
  switch (issue.type) {
    case "no_model_provider":
      return {
        title: "No model provider configured",
        message: /* @__PURE__ */ React.createElement(React.Fragment, null, "AI features cannot run until a model provider is configured", link, ".")
      };
    case "no_default_model_provider":
      return {
        title: "No default model provider",
        message: /* @__PURE__ */ React.createElement(React.Fragment, null, "AI features without a usable model provider of their own cannot run until a model provider is made the default", link, ".")
      };
    case "default_model_provider_disabled":
      return {
        title: "Default model provider disabled",
        message: /* @__PURE__ */ React.createElement(React.Fragment, null, "The default model provider ", /* @__PURE__ */ React.createElement(ProviderName, { providerId: issue.provider }), " is disabled by the server configuration. AI features without a usable model provider of their own cannot run until another model provider is made the default", link, ".")
      };
  }
};
const ModelProviderIssueAlert = ({ issue, linkToModelProviders }) => {
  const { title, message } = issueAlertContent(issue, /* @__PURE__ */ React.createElement(OnModelProvidersPage, { show: linkToModelProviders }));
  return /* @__PURE__ */ React.createElement(StyledAlert, { bsStyle: "warning", title }, message);
};
const AIFeaturesStatusAlerts = ({ isModelProvidersPage = false }) => {
  const { isPermitted } = usePermissions();
  const { aiDisabled, modelProviderIssue } = useAIFeaturesStatus();
  const showAIDisabled = aiDisabled && !isModelProvidersPage;
  const shownModelProviderIssue = aiDisabled ? void 0 : modelProviderIssue;
  const linkToModelProviders = !isModelProvidersPage && isPermitted("llm_provider:edit");
  if (!showAIDisabled && !shownModelProviderIssue) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(Alerts, null, showAIDisabled && /* @__PURE__ */ React.createElement(StyledAlert, { bsStyle: "warning", title: "AI features are disabled" }, "AI features are disabled by the administrator. No AI feature runs until they are turned on again", /* @__PURE__ */ React.createElement(OnModelProvidersPage, { show: linkToModelProviders }), "."), shownModelProviderIssue && /* @__PURE__ */ React.createElement(ModelProviderIssueAlert, { issue: shownModelProviderIssue, linkToModelProviders }))));
};
export default AIFeaturesStatusAlerts;
